import {
  AnalyticsAction,
  AnalyticsObjectType,
  AnalyticsParentPage,
  AnalyticsPlacementType,
  AnalyticsSubPage,
} from '@chewy/loyalty-common/constants';
import { buildLoyaltyAnalyticsEvent } from '@chewy/loyalty-common/utils';

// Placement details from the landing rows in Analytics Tag Builder V2 (E:J).
export enum LandingPagePlacementDetail {
  Page = 'landing_page',
  Hero = 'hero',
  StartTrial = 'start_trial_cta',
  StartTrialSticky = 'start_trial_sticky_cta',
  StartTrialStickyWidget = 'start_trial_sticky',
  Benefits = 'benefits',
  Testimonials = 'testimonials',
  TestimonialsRight = 'testimonials_right',
  TestimonialsLeft = 'testimonials_left',
  BenefitsTrial = 'benefits_trial',
  BenefitsTrialPayment = 'benefits_trial_payment',
  BenefitsTrialTerms = 'benefits_trial_terms_conditions',
  StartFreeTrial = 'start_free_trial_cta',
  BenefitsTrialClose = 'benefits_trial_close',
  Faq = 'faq',
  MembershipTerms = 'membership_terms',
}

export const buildStickyTrialAnalyticsEvent = (
  action: AnalyticsAction.Click | AnalyticsAction.Impression,
) =>
  buildLoyaltyAnalyticsEvent({
    action,
    objectType:
      action === AnalyticsAction.Click ? AnalyticsObjectType.Cta : AnalyticsObjectType.Widget,
    placementDetail:
      action === AnalyticsAction.Click
        ? LandingPagePlacementDetail.StartTrialSticky
        : LandingPagePlacementDetail.StartTrialStickyWidget,
    subPage: AnalyticsSubPage.None,
    placementType: AnalyticsPlacementType.Landing,
    parentPage: AnalyticsParentPage.Landing,
  });
